import React from 'react';

import classNames from 'classnames';

import classes from './DiffPercentLabel.module.scss';
import { getNumberWithSignView } from '../../../utils/stringUtils/getNumberWithSignView/getNumberWithSignView';

type DiffPercentLabelProps = {
  percentValue?: number;
  className?: string;
};

const DiffPercentLabel = ({ percentValue, className }: DiffPercentLabelProps) => {
  const comparingPercentageClass = classNames(classes.label, className, {
    [classes.negative]: percentValue && percentValue < 0,
    [classes.positive]: percentValue && percentValue > 0,
  });

  if (!percentValue) {
    return null;
  }

  return (
    <span className={comparingPercentageClass}>
      {getNumberWithSignView(percentValue, 2)}%
    </span>
  );
};

export { DiffPercentLabel };
